var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h3", { staticStyle: { padding: "1rem" } }, [
        _vm._v("Verlinkte Rabatte"),
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          { staticClass: "new-subscription" },
          [
            _c("v-select", {
              staticClass: "discount-filter",
              attrs: { items: _vm.discounts, placeholder: "Suche Rabatt" },
              model: {
                value: _vm.selectedDiscountId,
                callback: function ($$v) {
                  _vm.selectedDiscountId = $$v
                },
                expression: "selectedDiscountId",
              },
            }),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                attrs: {
                  id: "assign-discount-btn",
                  disabled: !_vm.selectedDiscountId,
                },
                on: {
                  click: function ($event) {
                    return _vm.assignDiscountToPharmacy()
                  },
                },
              },
              [_vm._v("\n          Rabatte verlinken\n      ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "subscribed-discounts" },
          [
            Object.keys(_vm.appliedDiscounts).length === 0
              ? _c("div", { staticClass: "no-discounts" }, [
                  _vm._v(
                    "\n        Es können keine Rabatte angezeigt werden\n      "
                  ),
                ])
              : _c("v-simple-table", {
                  staticClass: "discount-table",
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function () {
                        return [
                          _c("thead", [
                            _c("tr", { staticClass: "vuetify-wrapper" }, [
                              _c("th", [_vm._v("Rabatt Name")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Rabatt Beschreibung")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Rabatt Typ")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Rabatt Wert")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("ND Rabatt Typ")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("ND Rabatt Wert")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Rabatt Startdatum")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Rabatt Endtermin")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Rabatt Ist Aktiv?")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Aktionen")]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(
                              _vm.appliedDiscounts,
                              function (discount, id) {
                                return _c(
                                  "tr",
                                  {
                                    key: id,
                                    staticClass: "vuetify-wrapper",
                                    attrs: { "data-id": id },
                                  },
                                  [
                                    _c("td", [
                                      _vm._v(_vm._s(discount.discountName)),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(discount.description)),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translateDiscountType(
                                            discount.discountType
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.discountValueDisplay(discount)
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translateDiscountType(
                                            discount.flatRateDiscountType
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.flatRateDiscountValueDisplay(
                                            discount
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(discount.startDate)),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(discount.endDate)),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(discount.isActive)),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "unlink-discount-btn",
                                            attrs: {
                                              small: "",
                                              depressed: "",
                                              color: "error",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.isUnlinkDiscountDialogOpen = true
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { small: "" } },
                                              [_vm._v("mdi-trash-can-outline")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("unlink-discount-dialog", {
                                      attrs: {
                                        discountId: id,
                                        pharmacyId: _vm.pharmacyId,
                                      },
                                      model: {
                                        value: _vm.isUnlinkDiscountDialogOpen,
                                        callback: function ($$v) {
                                          _vm.isUnlinkDiscountDialogOpen = $$v
                                        },
                                        expression:
                                          "isUnlinkDiscountDialogOpen",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("h3", { staticStyle: { padding: "1rem", "margin-top": "2rem" } }, [
        _vm._v("Einmalige Gutschrift (Terminansicht)"),
      ]),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1 v-application--is-ltr",
        attrs: {
          headers: _vm.headers,
          items: _vm.oneTimeDiscountsAppointments,
          loading: _vm.isLoading,
          "no-data-text": "Keine Suchergebnisse",
          "loading-text": "Wird geladen...",
          "items-per-page": 5,
          "footer-props": {
            "items-per-page-options": [5, 10, 25],
            "show-first-last-page": true,
            "show-current-page": true,
            "items-per-page-text": "Zeilen pro Seite",
          },
        },
        scopedSlots: _vm._u([
          {
            key: "item.created",
            fn: function ({ item }) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$formatDate(item.created, "DD.MM.YYYY HH:mm")) +
                    "\n    "
                ),
              ]
            },
          },
          {
            key: "item.date",
            fn: function ({ item }) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$formatDate(item.date, "DD-MM-YYYY")) +
                    "\n    "
                ),
              ]
            },
          },
          {
            key: "item.mediation_charge",
            fn: function ({ item }) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      item.mediation_charge?.toFixed(2)?.replace(".", ",")
                    ) +
                    " €\n    "
                ),
              ]
            },
          },
          {
            key: "item.wf_state",
            fn: function ({ item }) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.translateWfState(item.wf_state)) +
                    "\n    "
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }